import { create } from "zustand";

interface A2PRegistrationState {
  isCompleted: boolean;
  setCompleted: (isInvited: boolean) => void;
}

export const useA2PRegistrationStore = create<A2PRegistrationState>((set) => ({
  isCompleted: false,
  setCompleted: (isCompleted) => set({ isCompleted }),
}));
